import { OrderExecutorUtils } from '../../Trading/OrderExecutorUtils';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { SessionSettings } from '../../SessionSettings';
import { OrderTif, OrderTifMap } from '@shared/utils/Trading/OrderTifEnum';
import { Resources } from '@shared/localizations/Resources';
import { TvOrderConvertor } from './TvOrderConvertor';
class _TvDurationConvertor {
    getAllowedDurationsForInstrumentAccount(instrument, account) {
        const allowedOrderTypes = this.getAllowedOrderTypes(instrument, account);
        return this.getAllowedDurations(allowedOrderTypes, instrument);
    }
    getAllAllowedDurations() {
        const allAllowedOrderTypes = this.getAllAlowedOrderTypes();
        return this.getAllowedDurations(allAllowedOrderTypes);
    }
    getAllowedDurations(allAllowedOrderTypes, instrument) {
        const tifsMap = this.getAllowedOrderTypesByTif(allAllowedOrderTypes, instrument);
        const durations = [];
        for (const tif of tifsMap.keys()) {
            const allowedOrderTypes = tifsMap.get(tif);
            if (allowedOrderTypes.length === 0)
                continue;
            const allowedTvOrderTypes = allowedOrderTypes.map(TvOrderConvertor.getTvOrderType);
            const duration = this.convertTifToDuration(tif, allowedTvOrderTypes);
            durations.push(duration);
        }
        return durations;
    }
    InvertMap(originalMap) {
        const invertedMap = new Map();
        const allAllowedOrderTypes = this.getAllAlowedOrderTypes();
        originalMap.forEach((tifs, orderType) => {
            tifs.forEach((tif) => {
                if (!invertedMap.has(tif)) {
                    invertedMap.set(tif, []);
                }
                if (!invertedMap.get(tif).includes(orderType) && allAllowedOrderTypes.includes(orderType)) {
                    invertedMap.get(tif).push(orderType);
                }
            });
        });
        return invertedMap;
    }
    getAllowedTvOrderTypes(instrument, account) {
        const rAllowedOrderTypes = this.getAllowedOrderTypes(instrument, account);
        return rAllowedOrderTypes.map((x) => TvOrderConvertor.getTvOrderType(x));
    }
    getAllowedOrderTypes(instrument, account) {
        const obj = OrderExecutorUtils.getAllowedOrderTypeDict(account, instrument, []);
        const keys = Object.keys(obj);
        const numericKeys = keys.map((key) => parseInt(key));
        const allowedOrderTypes = this.getAllAlowedOrderTypes();
        const filtered = numericKeys.filter((x) => allowedOrderTypes.includes(x));
        return filtered;
    }
    getAllowedOrderTypesByTif(allAllowedOrderTypes, instrument) {
        const tifsByOrderTypeMap = new Map();
        for (const orderType of allAllowedOrderTypes) {
            let tifs;
            if (instrument !== undefined) {
                tifs = OrderExecutorUtils.getAllowedTIFArray(orderType, instrument);
            }
            else {
                tifs = SessionSettings.GetAllowedTifsForOrderTypes([orderType]);
            }
            tifsByOrderTypeMap.set(orderType, tifs);
        }
        const tifsMap = this.InvertMap(tifsByOrderTypeMap);
        return tifsMap;
    }
    getAllAlowedOrderTypes() {
        const allowedOrderTypes = [
            OrderType.Market,
            OrderType.Stop,
            OrderType.Limit,
            OrderType.StopLimit
            // OrderType.TrailingStop // TrailingStop OrderType not exist in TV TradingPlatform
        ];
        return allowedOrderTypes;
    }
    getProtectedOrderTypes() {
        const protectedOrderTypes = [OrderType.SLTPLimit, OrderType.SLTPStop, OrderType.TRStop];
        return protectedOrderTypes;
    }
    convertTifToDuration(tif, allowedTvOrderTypes) {
        const duration = {
            hasDatePicker: tif === OrderTif.GTD,
            hasTimePicker: false,
            default: tif === OrderTif.Day,
            name: Resources.getResource(OrderTifMap[tif]),
            value: OrderTifMap[tif],
            supportedOrderTypes: allowedTvOrderTypes
        };
        return duration;
    }
}
export const TvDurationConvertor = new _TvDurationConvertor();
